import { Component, Vue } from 'vue-property-decorator'
import Cookies from 'js-cookie'
import { getPartnerProxyId, getToken, minValidityInSeconds } from '@/utils/KeycloakUtils'
import axios from 'axios'

const IS_RED_COOPERATION_PARTNER = 'isRedCooperationPartner'

@Component
export default class RedCooperationUtils extends Vue {
  public static isRedCooperationPartner(): boolean {
    const redCookie = Cookies.get(IS_RED_COOPERATION_PARTNER)
    if (redCookie === undefined) {
      // if cookie is unset, we assume red cooperation for security reasons
      return true
    }
    return redCookie === 'true'
  }
}

export interface RedPartnerStatus {
  redCooperationPartner: boolean
}

export async function setRedPartnerStatusCookie(): Promise<boolean> {
  return new Promise<boolean>((resolve, reject) => {
    getRedPartnerStatus()
      .then((status) => {
        Cookies.set(IS_RED_COOPERATION_PARTNER, String(status), { sameSite: 'lax' })
        const redCookie = Cookies.get(IS_RED_COOPERATION_PARTNER)
        if (redCookie === undefined) {
          resolve(false)
        }
        resolve(true)
      })
      .catch(() => {
        resolve(false)
      })
  })
}

async function getRedPartnerStatus(): Promise<boolean> {
  const partnerProxyId: string | null = getPartnerProxyId()
  if (!partnerProxyId) {
    throw new Error('No partner proxy id available!')
  }

  const token = await getToken()

  try {
    const response = await axios.get(
      `${window.ENV_CONFIG.SERVICE_HOSTS.PARTNER_PROXY}/advisor/red-cooperations/${partnerProxyId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          KeyId: window.ENV_CONFIG.API_KEY
        }
      }
    )
    const data = response.data.data as RedPartnerStatus
    return data.redCooperationPartner
  } catch {
    return true
  }
}
